<template>
  <transition name="fade-transition" :mode="mode">
    <slot />
  </transition>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'FadeTransition' })
export default class FadeTransition extends Vue {
  @Prop({ type: String, default: 'out-in' })
  private mode!: string;
}
</script>

<style lang="less" scoped>
.fade-transition {
  &-enter-active,
  &-leave-active {
    transition: opacity 0.5s;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
